"use client";
import { useEffect, useState } from "react";

const FAQ = ({ faqs, title = "Frequently Asked Questions", description = "Common questions and answers about our services" }) => {
  const [openIndex, setOpenIndex] = useState(null);

  // Function to toggle the FAQ
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Add FAQ schema for SEO
  useEffect(() => {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "name": title,
      "description": description,
      "mainEntity": faqs.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        },
        "keywords": extractKeywords(faq.question + " " + faq.answer),
        "datePublished": new Date().toISOString().split('T')[0],
        "author": {
          "@type": "Organization",
          "name": "chatmitra",
          "url": "https://chatmitra.com/"
        }
      }))
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(faqSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [faqs, title, description]);

  // Function to extract keywords (similar to your original)
  const extractKeywords = (text) => {
    const commonWords = new Set(['a', 'an', 'the', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by']);
    return text
      .toLowerCase()
      .split(/\W+/)
      .filter(word => word.length > 2 && !commonWords.has(word))
      .slice(0, 5)
      .join(', ');
  };

  return (
    <section className="section bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <h1 className="text-center font-bold text-3xl mb-8 text-gray-900">{title}</h1>
        <div className="grid gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white shadow-lg rounded-lg overflow-hidden transition-transform transform hover:scale-[1.02] duration-200">
              <div
                className="p-6 cursor-pointer flex justify-between items-center"
                onClick={() => toggleFAQ(index)}
              >
                <h4 className="font-semibold text-lg text-gray-800">{faq.question}</h4>
                <span className="text-gray-600 text-xl">{openIndex === index ? "-" : "+"}</span>
              </div>
              {openIndex === index && (
                <div className="p-6 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;